var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7949 0.5H1.79492C0.969922 0.5 0.302422 1.175 0.302422 2L0.294922 11C0.294922 11.825 0.969922 12.5 1.79492 12.5H13.7949C14.6199 12.5 15.2949 11.825 15.2949 11V2C15.2949 1.175 14.6199 0.5 13.7949 0.5ZM13.4949 3.6875L8.19242 7.0025C7.95242 7.1525 7.63742 7.1525 7.39742 7.0025L2.09492 3.6875C2.01972 3.64528 1.95386 3.58825 1.90134 3.51984C1.84882 3.45143 1.81072 3.37308 1.78935 3.28953C1.76799 3.20597 1.7638 3.11895 1.77704 3.03373C1.79028 2.94851 1.82067 2.86686 1.86638 2.79373C1.91209 2.72059 1.97217 2.65749 2.04297 2.60825C2.11377 2.559 2.19383 2.52463 2.27829 2.50722C2.36276 2.48981 2.44988 2.48973 2.53439 2.50696C2.61889 2.5242 2.69902 2.5584 2.76992 2.6075L7.79492 5.75L12.8199 2.6075C12.8908 2.5584 12.971 2.5242 13.0555 2.50696C13.14 2.48973 13.2271 2.48981 13.3116 2.50722C13.396 2.52463 13.4761 2.559 13.5469 2.60825C13.6177 2.65749 13.6778 2.72059 13.7235 2.79373C13.7692 2.86686 13.7996 2.94851 13.8128 3.03373C13.826 3.11895 13.8219 3.20597 13.8005 3.28953C13.7791 3.37308 13.741 3.45143 13.6885 3.51984C13.636 3.58825 13.5701 3.64528 13.4949 3.6875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7a6e4f4d1a7b6cfb2b3ed34ab818d85d.svg";
export { ForwardRef as ReactComponent };